// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ContactUsPage from "../pages/ContactUs/ContactUs";
const __wvcRoutePaths = ["/ContactUsPage", "/contact-us"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["asia", "asiapage", "bespoke-cruises", "bespokecruisespage", "circuit-cash", "circuitcashpage", "contact-us", "contactuspage", "europe", "europepage", "experiences", "experiencespage", "global-circuit-queer-party-experiences", "globalcircuitqueerpartyexperiencespage", "home", "homepage", "latin-america", "latinamericapage", "north-america", "northamericapage", "our-story", "ourstorypage", "plan-your-bespoke-journey", "planyourbespokejourneypage", "post", "pride-festivals", "pridefestivalspage", "promotion", "promotionpage", "rave-edm", "raveedmpage", "the-difference", "the-hub", "thedifferencepage", "thehubpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ContactUsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ContactUsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
